import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';

import { IconSize } from 'constants/coreDesignSystem';

import {
  bannerBodyStyles,
  bannerIconWrapperStyles,
  bannerTextWrapperStyles,
  bannerTitleStyles,
  bannerWrapperStyles,
} from './ManufacturedHomeContactsBanner.styles';
import { ManufacturedHomeContactsBannerTestIds } from './ManufacturedHomeContactsBanner.testIds';

const ManufacturedHomeContactsBanner = () => (
  <Box data-testid={ManufacturedHomeContactsBannerTestIds.ROOT} sx={bannerWrapperStyles}>
    <Box sx={bannerIconWrapperStyles}>
      <InfoIcon size={IconSize[20]} />
    </Box>

    <Box sx={bannerTextWrapperStyles}>
      <Typography sx={bannerTitleStyles} variant="medium14">
        Manufactured home loan contacts
      </Typography>

      <Typography sx={bannerBodyStyles} variant="regular12">
        These contacts appear only for manufactured home loan types. Select a contact to auto-fill
        its details — Broker and Investor details are read-only; Dealer details can be edited.
      </Typography>
    </Box>
  </Box>
);

export default memo(ManufacturedHomeContactsBanner);
